import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

class TokenService {
  setToken(token) {
    Cookies.set("token", token, {
      secure: true,
      sameSite: "Strict",
    });
  }

  getToken() {
    return Cookies.get("token");
  }

  removeToken() {
    Cookies.remove("token");
  }

  getUserId() {
    const token = this.getToken();
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.userId;
    }
    return null;
  }

  getOrganizationId() {
    const token = this.getToken();
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.organizationId;
    }
    return null;
  }

  getRole() {
    const token = this.getToken();
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.role;
    }
    return null;
  }

  isValid() {
    const token = this.getToken();
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    }
    return false;
  }

  isLoggedIn() {
    return !!this.getToken();
  }
}

const tokenServiceInstance = new TokenService();

export default tokenServiceInstance;
